import React, { useEffect, useState } from 'react';
import contractsSignaturesFtuxLogo from '../../../../../../images/contracts/contracts-signatures-ftux.png';
import ButtonComponent from '../../../../../common-components/ButtonComponent/ButtonComponent';
import { signatureImageList, signatureTextList } from '../../../../../../services/signatures.service';
import NewLoader from '../../../../../common-components/Loaders/NewLoader';
import SignatureSelectedIcon from '../../../../../Icons/icons/SignatureSelectedIcon';
import ShortString from '../../../../../common-components/ShortString/ShortString';

export default function SavedSignatures({ onClose, onUploadFinish }) {
  const [isLoading, setIsLoading] = useState(false);
  const [savedTextSignatures, setSavedTextSignatures] = useState([]);
  const [savedImgSignatures, setSavedImgSignatures] = useState([]);
  const [selectedSignId, setSelectedSignId] = useState('');
  const [selectedSign, setSelectedSign] = useState(null);

  const disabled = isLoading || !selectedSignId;

  const fetchSignatures = async () => {
    setIsLoading(true);
    try {
      const imgRes = await signatureImageList();
      const res = await signatureTextList();
      setSavedTextSignatures(res?.data || []);
      setSavedImgSignatures(imgRes?.data || []);
    } catch (error) {
      console.log(error, '#eyy383793 failed to fetch signature lists');
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchSignatures();
  }, []);

  let content;
  if (isLoading) {
    content = (
      <div className="saved-signatures-loader">
        <NewLoader style={{ height: 50 }} />
      </div>
    );
  } else if (savedTextSignatures?.length + savedImgSignatures.length > 0) {
    content = (
      <>
        <div className="saved-signatures-container" style={{ overflowY: 'auto' }}>
          {savedTextSignatures.map((typedSignature) => (
            <div
              className={`saved-sign ${typedSignature?._id === selectedSignId ? 'saved-sign-selected' : ''}`}
              key={typedSignature?._id}
              style={{
                fontFamily: typedSignature?.fontStyling?.fontFamily,
                fontSize: '26px',
              }}
              onClick={() => {
                setSelectedSignId(typedSignature?._id);
                setSelectedSign(typedSignature);
              }}>
              <ShortString name={typedSignature?.text} stringLength={18} />

              <SignatureSelectedIcon className="signature-selected-icon" />
            </div>
          ))}

          {savedImgSignatures.map((imgSignature) => (
            <div
              className={`saved-sign ${imgSignature?._id === selectedSignId ? 'saved-sign-selected' : ''}`}
              key={imgSignature?._id}
              style={{
                fontFamily: imgSignature?.fontStyling?.fontFamily,
              }}
              onClick={() => {
                setSelectedSignId(imgSignature?._id);
                setSelectedSign(imgSignature);
              }}>
              <img
                alt=""
                src={imgSignature?.imageSignatureUrl}
                style={{
                  maxWidth: '100%',
                  objectFit: 'contain',
                  maxHeight: 70,
                }}
              />
              <SignatureSelectedIcon className="signature-selected-icon" />
            </div>
          ))}
        </div>
      </>
    );
  } else {
    content = (
      <div className="saved-signatures-ftux">
        <div>
          <img src={contractsSignaturesFtuxLogo} alt="contract-signature-ftux" />
        </div>
        Sign at least one contract before seeing a saved signature.
      </div>
    );
  }

  return (
    <>
      {content}

      <div className="sign-contract-buttons-container">
        <ButtonComponent onClick={onClose} variant="secondary">
          Cancel
        </ButtonComponent>

        <ButtonComponent
          disabled={disabled}
          onClick={() => {
            if (disabled) return;

            if (selectedSign?.text && selectedSign?.fontStyling) {
              onUploadFinish({
                type: 'typed',
                text: selectedSign?.text,
                fontFamily: selectedSign?.fontStyling?.fontFamily,
                _id: selectedSign?._id,
              });
            } else if (selectedSign?.imageKey) {
              onUploadFinish({
                type: 'image',
                src: selectedSign?.imageSignatureUrl,
                _id: selectedSign?._id,
              });
            }
          }}
          type="submit"
          disabledStyle={{ fontSize: '16px' }}>
          Upload
        </ButtonComponent>
      </div>
    </>
  );
}
